import { getAxiosInstance } from '../../np-rest/rest';
import { snackActions } from '../../sc-utilities/SnackBar';

// The Securaze-curated grading profiles the customer can choose from.
export const getAiGradingPresets = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            const res = await rest.post('ai-grading/presets', params);
            if (res && res.data && res.data.succeeded) {
                return res.data.result.data;
            }
            return [];
        } catch (error) {
            return [];
        }
    };
};

export const getAiGradingSettings = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            const res = await rest.post('ai-grading/settings', params);
            if (res && res.data && res.data.succeeded) {
                return res.data.result.data;
            }
            return null;
        } catch (error) {
            return null;
        }
    };
};

export const saveAiGradingSettings = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            const res = await rest.post('ai-grading/settings/save', params);
            if (res && res.data && res.data.succeeded) {
                snackActions.snackBar({ message: 'AI grading profile saved.', options: { variant: 'success' } });
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : 'Could not save AI grading profile.'}`,
                options: { variant: 'warning' },
            });
            return null;
        } catch (error) {
            snackActions.snackBar({ message: `${error.message}`, options: { variant: 'error' } });
            return null;
        }
    };
};
